export default `
#### کانورژن چیست؟
کانورژن در واقع همان اقدامی است که شما جهت انجام آن به بازاریابان کمیسیون می‌دهید. برای مثال زمانی که مشتری از سمت یک بازاریاب وارد فروشگاه شما می‌شود و خریدی انجام می‌دهد، اقدام خرید یک کانورژن است و شما در ازای آن به بازاریاب کمیسیون پرداخت می‌کنید.

#### اسکریپت ردیابی کانورژن‌ها چیست؟
اسکریپت ردیابی کانورژن‌ها(affili-js) یک قطعه کد نوشته شده به زبان جاوااسکریپت است که اطلاعات مورد نیاز جهت ردیابی کانورژن‌ها را جمع‌آوری کرده و به افیلی ارسال می‌کند.
##### ویژگی‌های مهم اسکریپت
- ✅ ردیابی کانورژن‌ها
- ✅ شخصی سازی کمیسیون‌ها
- ✅ ردیابی کدهای تخفیف و لینک‌ها
- ✅ کمیسیون بر اساس دسته‌بندی
- ⌛ تعیین واحد پولی

#### نصب و پیکربندی اسکریپت
برای نصب اسکریپت کافی است کد زیر را کپی کرده و در تگ \`<head>\` تمامی صفحات سایت قرار دهید.

\`\`\`javascript
<script async src="https://analytics.affili.ir/scripts/affili-js.js"></script>
<script>
  window.affiliData = window.affiliData || [];function affili(){affiliData.push(arguments);}

  affili('create', 'YOUR ACCOUNT ID');
  affili('detect');
</script>
\`\`\`

مقدار \`YOUR ACCOUNT ID\` را با مقدار درست جایگذاری کنید. \`ACCOUNT ID\` را می‌توانید در بالا همین صفحه پیدا کنید.

> این قطعه کد مربوط به ردیابی کلیک‌هایی است که افیلیت‌ها به سمت شما می‌فرستند. صرف نظر از نوع پیاده سازی برنامه افیلیت، شما باید این کد را در تگ \<head\> تمامی صفحات قرار دهید.

#### ردیابی کانورژن‌ها
برای ردیابی کانورژن باید قطعه کد زیرا را بعد از رخ دادن اقدام موردنظر اجرا کنید. این کد معمولا در \`thank you page\` و درست بعد از اینکه سفارش کامل شد یا داده‌های مربوط به لید جمع‌آوری شد، قرار می‌گیرد.

قطعه کد زیر مربوط به حالتی است که تنها یک نوع کمیسیون تعریف شده، در صورتی که بیش از یک کمیسیون تعریف کرده‌اید کد را متناسب با بخش بعد تغییر دهید.

\`\`\`javascript
affili(
  'conversion', 'UNIQUE_CONVERSION_ID', 'CONVERSION_AMOUNT', 'COMMISSION_NAME', <options>, 'DELETE_COOKIE'
);
\`\`\`

- **UNIQUE_CONVERSION_ID:** یک شناسه یکتاست که باید در سیستم خود برای هر کانورژن ایجاد کنید. شما باید این متن را با یک تگ یا متغیر واقعی جایگزین کنید تا مقدار مربوطه را در هر کانورژن به صورت خودکار مقداردهی کند. شناسه یکتا می‌تواند هر چیزی که برای شما معنادار است باشد و باید برای هر کانورژن نیز منحصربفرد باشد. به طور مثال: شماره سفارش، شماره تراکنشو غیره. پس از ثبت کانورژن می‌توانید این شناسه را در کنار کانورژن در پنل افیلی بخش کانورژن‌ها مشاهده کنید. این امر باعث می‌شود که مدیریت داده‌های موجود در افیلی و سیستم شما آسان‌تر شود.
- **CONVERSION_AMOUNT:** مبلغ کل کانورژن است. ما از این مقدار برای محاسبه کمیسیون‌های درصدی استفاده می‌کنیم. شما باید این متن را با یک تگ یا متغیر واقعی جایگزین کنید تا مقدار مربوطه را در هر کانورژن به صورت خودکار مقداردهی کند.
- **COMMISSION_NAME:** نام منحصربفردی است که شما در بخش کمیسیون‌ها در پنل افیلی برای کانورژن‌ تعریف کرده‌اید این نام در فرم تعریف کمیسیون همان فیلد کلید است.

> کلید کمیسیون برای کلیک مقدار \`click\` و برای کمیسیون پیش‌فرض مقدار \`default\` است. این کلیدها غیر قابل استفاده برای سایر کمیسیون‌ها و غیر قابل تغییر هستند.

- **&lt;options&gt;:**  آبجکتی است که برخی پارامترهای کم اهمیت‌تر درآن جای گرفته. و در زمان پیاده‌سازی اسکریپت ممکن است برخی از این پارامترها مورد استفاده قرار گیرد.

**توجه:** واحد پولی افیلی در حال حاضر ریال است. در نتیجه تمامی قیمت‌ها باید به صورت ریال داده شود.

<style>
#options-table tr th,
#options-table tr td {
	text-align: center;
}
td, th {
    border: 1px solid #dfe2e5;
    padding: .6em 1em;
}
table {
	border-collapse: collapse;
    margin: 1rem 0;
    display: block;
    overflow-x: auto;
}
</style>

<table id="options-table">
<thead>
	<tr>
		<th style="width: 5%; ">نام</th>
		<th style="width: 5%;">نوع</th>
		<th style="width: 5%;">اجباری</th>
		<th style="width: 10%;">مقدار پیش‌فرض</th>
		<th>توضیحات</th>
	</tr>
</thead>
<tbody>
	<tr>
		<td>meta_data</td>
		<td>text</td>
		<td>خیر</td>
		<td>null</td>
		<td style="text-align:right;">
			<span>
				این بخش جهت ذخیره سازی داده‌هایی است که ممکن است در آینده نیازمند آن باشید.
			</span>
			<span style="display:block; padding: 5px; background-color: rgb(239 225 254); color: rgb(61 1 155);">
				<code>meta_data</code> به صورت یک پارامتر متنی همراه با کانورژن ذخیره می‌شود و ما محتویات این پارمتر را مورد ارزیابی قرار نمی‌دهیم.
			</span>
		</td>
	</tr>
	<tr>
		<td>coupon</td>
		<td>string</td>
		<td>خیر</td>
		<td>null</td>
		<td style="text-align:right;">
			<span>
				در صورتی که کانورژن از نوع <code>sale</code> است و در پنل نیز برای نمایش‌دهند(ها) کد تخفیف تعریف کرده‌اید، جهت اعمال نرخ کاهش لازم است کد تخفیف استفاده شده در خرید توسط این پارامتر به افیلی ارسال شود.
			</span>
		</td>
	</tr>
</tbody>
</table>

- **DELETE_COOKIE:** به صورت پیش‌فرض بعد از اینکه یک کانورژن ثبت می‌شود کوکی‌های مربوط به ردیابی مشتری نیز پاک می‌شوند. در صورتی که می‌خواهید به افیلیت در خرید‌های بعدی مشتری نیز کمیسیون تعلق گیرد مقدار این پارامتر را \`false\` قرار دهید.

> برای مثال فرض کنید می‌خواهید علاوه‌بر پرداخت کمیسیون در ازای خرید در ازای ثبت‌نام نیز به افیلیت‌ها کمیسیون پرداخت کنید. در این صورت برای اینکه کوکی مشتری بعد از ثبت کانورژن ثبت‌نام پاک نشود مقدار این پارامتر را باید \`false\` قرار دهید.

#### کانورژن‌هایی با بیش از یک کمیسیون
زمانی که کانورژن از نوع خرید(\`sale\`) است. مشتری ممکن است بیش‌تر از یک کالا خریداری کرده باشد؛ در نتیجه این امکان وجود دارد که محصولات خریداری شده در بیش‌تر از یک دسته‌بندی قرار گرفته باشند و از آن‌جایی که برای دسته‌بندی‌های مختلف کمیسیون‌های متفاوتی درنظر گرفته شده دیگر از طریق کد بالا نمی‌توان کانورژن را ردیابی کرد. برای اعمال چندین کمیسیون از قطعه کد زیر استفاده نمایید.

\`\`\`JS
affili(
  'conversionMulti', 'UNIQUE_CONVERSION_ID', 'CONVERSION_AMOUNT', [<commission>], <options>, 'DELETE_COOKIE'
);
\`\`\`

در این متد \`<commission>\` آبجکتی است که کلید کمیسیون و مقدار قیمت مرتبط به آن را در خود دارد.

<style>
#commission-table tr th,
#commission-table tr td {
	text-align: center;
}
</style>

<table id="commission-table">
<thead>
	<tr>
		<th style="width: 5%; ">نام</th>
		<th style="width: 5%;">نوع</th>
		<th style="width: 5%;">اجباری</th>
		<th style="width: 10%;">مقدار پیش‌فرض</th>
		<th>توضیحات</th>
	</tr>
</thead>
<tbody>
	<tr>
		<td>name</td>
		<td>string</td>
		<td>بلی</td>
		<td>-</td>
		<td style="text-align:right;">
			کلید کمیسیون مربوطه
		</td>
	</tr>
	<tr>
		<td>sub_amount</td>
		<td>string</td>
		<td>بلی</td>
		<td>-</td>
		<td style="text-align:right;">
			قیمت مربوط به این کلید
		</td>
	</tr>
</tbody>
</table>

##### مثال:
فرض کنید فروشگاه اینترنتی شما سه دسته‌بندی **کالا دیجیتال**، **آرایشی و بهداشتی** و **پوشاک** دارد و شما کمیسیون‌های زیر را در نظر گرفته‌اید.

| دسته‌بندی | کلید کمیسیون | درصد کمیسیون |
| ------------ | ------------ | -------- |
| کالای دیجیتال | digital | 2% |
| آرایشی و بهداشتی | arayeshi | 15% |
| پوشاک | pooshak | 10% |

مشتری از طریق یکی از افیلیت‌ها وارد سایت شده و محصولات زیر را با استفاده از کد تخفیف **affili** خریداری می‌نماید.

| آیدی محصول | عنوان محصول  | دسته‌بندی | قیمت اصلی(تومان) | قیمت با تخفیف(تومان) | تعداد | قیمت نهایی(تومان) |
| ---------- | ----- | ------------- | --------- | -------- | ------------ | ---------- |
| 245 | گوشی موبایل سامسونگ | کالای دیجیتال | 4,000,000 | 3,900,000 | 2 | 7,800,000 |
| 356 | تی‌شرت | پوشاک | 310,000 | 250,000 | 1 | 250,000 |

شماره پیگیری خرید \`1243537656\`

در صفحه \`thank you page\` کد زیر جهت ثبت کانورژن قرار خواهد گرفت.
\`\`\` JS
let commissions = [
  {
    name: 'digital',
    sub_amount: 78000000
  },
  {
    name: 'pooshak',
    sub_amount: 2500000
  }
];
let options = {
  coupon: 'affili'
};
affili('conversionMulti', 1243537656, 80500000, commissions, options);
\`\`\`
`